<template>
  <div class="basicInformation">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.FabricReport.GENERAL_INFORMATION') }}
    </div>
    <div class="basicInf-con">
      <ul>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.FabricReport.Client_Name') }}：</span
          >
          <span>{{ fabricDetails.freportClientname }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.FabricReport.Factory_Name') }}：</span
          >
          <span>{{ fabricDetails.freportVendorname }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.FabricReport.Factory_Address') }}：</span
          >
          <span>{{ fabricDetails.freportLoadigaddress }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.FabricReport.PO_Number') }}：</span
          >
          <span>{{ fabricDetails.orderId }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.FabricReport.Product_Name') }}：</span
          >
          <span>{{ fabricDetails.freportProductname }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.FabricReport.Style_Model_Number') }}：</span
          >
          <span>{{ fabricDetails.freportItemnumber }}</span>
        </li>
      </ul>
      <ul>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.FabricReport.Order_Quantity') }}：</span
          >
          <span>{{ fabricDetails.freportCount }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.FabricReport.Documents') }}：</span
          >
          <span>{{ fabricDetails.freportPackinginfo }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.FabricReport.Inspectors') }}：</span
          >
          <span>{{ fabricDetails.freportInspector }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.FabricReport.Factory_Representative') }}：</span
          >
          <span>{{ fabricDetails.freportVendorperson }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.FabricReport.Inspection_Started_at') }}：</span
          >
          <span>{{
            fabricDetails.gmtCreate != null && fabricDetails.gmtCreate != ''
              ? $moment(fabricDetails.gmtCreate).format('YYYY-MM-DD HH:mm')
              : ''
          }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.FabricReport.Inspection_Completed_at') }}：</span
          >
          <span>{{
            fabricDetails.freportCreatedate != null &&
            fabricDetails.freportCreatedate != ''
              ? $moment(fabricDetails.freportCreatedate).format(
                  'YYYY-MM-DD HH:mm',
                )
              : ''
          }}</span>
        </li>
      </ul>
      <!-- <div class="prodeImg">
        <div v-if="fmediaProductphoto == undefined"></div>
        <div v-else-if="fmediaProductphoto.length == 0"></div>
        <div v-else>
          <img :src="config.urlImg + fmediaProductphoto[0].mediaPath" />
        </div>

        <p>产品照片</p>
      </div> -->
      <div class="prodeImg">
        <div class="img">
          <show-img
            :data="[fmediaProductphoto[0]]"
            :otherData="{
              mediaName: '',
              mediaType: '',
              personId: '',
              orderId: '',
              reportId: '',
              mediaDesc: '',
            }"
            :id="String(id)"
          ></show-img>
        </div>
        <!-- <div v-if="fmediaProductphoto == undefined"></div>
        <div v-else-if="fmediaProductphoto.length == 0"></div>
        <div v-else>
          <img :src="config.urlImg + fmediaProductphoto[0].mediaPath" />
        </div>

        <p>产品照片</p> -->
      </div>
    </div>
  </div>
</template>
<script>
import showImg from './showImg';
export default {
  name: 'descriptionOfGoods',
  data() {
    return {
      id: this.$route.query.id,
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),

      // loading: false,
      imageUrl: '',
      productPhotoList: [],
      otherData: {
        mediaName: '产品照片',
        mediaType: 3,
        personId: '',
        orderId: '',
        reportId: '',
        mediaDesc: 'fmediaProductphoto',
      },
    };
  },
  components: {
    showImg,
  },
  computed: {
    fabricDetails: {
      get() {
        return this.$store.state.report.fabricDetails;
      },
      set(val) {
        this.$store.commit('report/save', { fabricDetails: val });
      },
    },
    fmediaProductphoto: {
      get() {
        return this.$store.state.report.fabricImgList.fmediaProductphoto;
      },
      // set(val) {
      //   this.$store.commit('report/save', { imgList: val });
      // },
    },
  },
  methods: {
    //打开修改弹窗
    getDetail() {
      this.$http
        .post('/hzwmj/workorder-fabricreport/getFabricInfo', {
          id: this.id,
        })
        .then(data => {
          if (data) {
            this.fabricDetails = data;
          } else {
            this.fabricDetails = {};
          }
        })
        .catch(() => {
          this.fabricDetails = {};
        });
    },
    handleCancel() {
      this.productPhotoList = [];
      this.visible = false;
    },
  },
};
</script>
<style lang="less">
.basicInformation {
  .basicInf-con {
    display: flex;
    .basicInf-p1 {
      display: inline-block;
      width: 120px;
    }
    > ul {
      width: 40%;
      li {
        line-height: 40px;
      }
    }
    > div {
      width: 20%;
      text-align: center;
      // img {
      //   width: 60%;
      //   margin: 50px 0 10px 0;
      // }
    }
  }
  // .prodeImg > div {
  //   display: inline-block;
  //   width: 160px;
  //   height: 120px;
  //   border: 1px solid rgb(202, 202, 202);
  //   text-align: center;
  //   margin: 10px;
  //   overflow: hidden;
  //   margin-top: 30px;
  //   img {
  //     max-width: 100%;
  //     max-height: 100%;
  //   }
  // }
}
.basicinf-updataForm {
  .ant-form-item {
    width: 50%;
    display: inline-block;
    .ant-form-item-label {
      text-align: left;
    }
  }
}
</style>
